"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDetailContext = exports.detailContext = exports.DetailProvider = void 0;
var _react = require("react");
const detailContext = exports.detailContext = /*#__PURE__*/ (0, _react.createContext)({
    breadcrumbs: [],
    firstName: null,
    productBoxConfiguration: {},
    lastName: null,
    products: []
});
const DetailProvider = exports.DetailProvider = detailContext.Provider;
const useDetailContext = ()=>(0, _react.useContext)(detailContext);
exports.useDetailContext = useDetailContext;
